var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"Container d-flex flex-column min-vh-100"},[_c('the-navbar',{attrs:{"toolRouteIsActive":_vm.toolRouteIsActive}}),_c('div',{staticClass:"flex-grow-1 body-container"},[_vm._t("default")],2),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }